import { Component, inject } from '@angular/core';
import { User } from 'src/app/models/user.model';
import { FormGroup, FormBuilder, Validators, FormsModule, ReactiveFormsModule, AbstractControl, ValidationErrors, ValidatorFn } from "@angular/forms";
import { AccountService, SupportSubject, SupportSubjectToLabelMapping } from 'src/app/services/account.service';
import { AccountComponent } from 'src/app/account/account.component';
import { NotificationService } from 'src/app/services/notification.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';


@Component({
    selector: 'app-account-assistance',
    templateUrl: './account-assistance.component.html',
    styleUrls: ['./account-assistance.component.css'],
    imports: [FormsModule, ReactiveFormsModule]
})
export class AccountAssistanceComponent {

  private formBuilder = inject(FormBuilder);
  private accountService = inject(AccountService);
  private notificationService = inject(NotificationService);

  public SupportSubjectToLabelMapping = SupportSubjectToLabelMapping;
  public supportSubjectTypes = Object.values(SupportSubject);

  user: User;

  public ContactForm: FormGroup;

  constructor() {
    this.ContactForm = this.formBuilder.group({
      'ContactName': ['', this.ValidatorName()],
      'ContactEmail': ['', Validators.compose([Validators.email, Validators.pattern('^[A-Za-z0-9._%+-]+@[A-Za-z0-9._%+-]{2,}[.][A-Za-z]{2,}$'), this.ValidatorEmail()])],
      'ContactSubject': ['', Validators.required],
      'ContactMessage': ['', Validators.required],
      'contactCopy': [true],
    });

    this.accountService.userObservable
      .pipe(takeUntilDestroyed())
      .subscribe((next: User) => {
        this.user = next;
      });
  }

  onSubmit() {
    if (this.ContactForm.invalid) {
      return;
    }
    let name: string;
    let email: string;
    if (this.user.first_name !== undefined)
      name = this.user.first_name + this.user.last_name;
    else name = this.ContactForm.value.ContactName;

    if (this.user.email !== undefined)
      email = this.user.email;
    else email = this.ContactForm.value.ContactEmail;

    this.accountService.sendSupportMessage(
      name,
      email,
      this.ContactForm.value.ContactSubject,
      this.ContactForm.value.ContactMessage,
      this.ContactForm.value.contactCopy
      ).subscribe(() => {
        this.notificationService.success('Your message has been sent.');
        this.ContactForm.reset();
    }, (_error) => {
      this.notificationService.error('Failed to send message. Please try again later.');
    });
  }

  ValidatorName(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      if (this.user?.first_name !== undefined) { return null; }
      return control.value ? null : { required: true };
    };
  }

  ValidatorEmail(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      if (this.user?.email !== undefined) { return null; }
      return control.value ? null : { required: true };
    };
  }

}
